import { h, Component, Host, Element } from "@stencil/core";
import pfx from "../../../../utils/style-class-prefix-helper";

/**
 * @slot [unnamed] - holds up to two column components.
 */
@Component({
  tag: "eon-ui-navigation-toolbar",
  styleUrl: "navigation-toolbar.scss",
  shadow: true
})
export class NavigationToolbar {
  @Element() hostElement: HTMLEonUiNavigationToolbarElement;

  render() {
    return (
      <Host>
        <nav id="toolbar-navigation" aria-label="Navigation Toolbar" class={pfx("navigation-toolbar-wrapper")}>
          <div
            class={pfx({
              "navigation-toolbar-inner": true
            })}
          >
            <slot />
          </div>
        </nav>
      </Host>
    );
  }
}
